<script setup>
import { watch, ref } from 'vue';
import { useFVStore } from '../../../stores/formvibes';

const props = defineProps(['row','status']);
const store = useFVStore();

const currentStatus = ref(props.row.fv_status);
const isVisible = ref(false);

watch(()=>{
    currentStatus.value = props.status?.filter((s) => s.key === props.row.fv_status)[0] || props.status[1]
})
const setVisible = () => {
    isVisible.value = !isVisible.value;
}
const statusClick = (value, row) => {
    setVisible();
    store.updateStatus(value, row);
    currentStatus.value = value;
}
</script>
<template>
    <div>
        <el-popover placement="bottom" :width="100" :visible="isVisible" popper-class="fv-status-list-wrapper">
            <template #reference>
                <el-tag :color="currentStatus.bgColor" size="defult" effect="light" @click.stop="setVisible" class="fv-status">
                    <span :style="{ 'color': currentStatus.textColor }">{{currentStatus.value}}</span>
                </el-tag>
            </template>
            <div class="fv-status-list">
                <el-tag v-for="stts in props.status" @click="statusClick(stts.key,props.row )" :key="stts.key" :color="stts.bgColor" effect="light">
                    <span :style="{ 'color': stts.textColor }">{{stts.value}}</span>
                </el-tag>
            </div>
        </el-popover>
    </div>
</template>